import { render, staticRenderFns } from "./ProblemsPage.vue?vue&type=template&id=6936e872&"
import script from "./ProblemsPage.vue?vue&type=script&lang=js&"
export * from "./ProblemsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports